var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDigital(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2204",
    transform: "translate(-4409 -3092)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 35",
    cx: 31,
    cy: 31,
    r: 31,
    transform: "translate(4409 3092)",
    style: {
      fill: "rgba(255,115,29,.1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 35.2H6.55A2.539 2.539 0 0 1 4 32.65v-22.1A2.539 2.539 0 0 1 6.55 8H34.6v2.55H6.55v22.1h5.95zm4.25 0v-2.8a5.993 5.993 0 0 1-1.233-1.636 4.233 4.233 0 0 1 0-3.868 5.993 5.993 0 0 1 1.233-1.636v-2.81h5.95v2.805a5.993 5.993 0 0 1 1.233 1.636 4.233 4.233 0 0 1 0 3.868A5.993 5.993 0 0 1 22.7 32.4v2.8zm2.975-3.4a2.975 2.975 0 1 0-2.1-.871 2.867 2.867 0 0 0 2.1.871zm17 3.4h-8.5a1.307 1.307 0 0 1-1.275-1.275v-15.3a1.2 1.2 0 0 1 .383-.914 1.259 1.259 0 0 1 .892-.361h8.5A1.236 1.236 0 0 1 38 18.625v15.3a1.259 1.259 0 0 1-.361.892 1.2 1.2 0 0 1-.914.383zM29.5 32.65h5.95V19.9H29.5z",
    transform: "translate(4419 3101.4)",
    style: {
      fill: "#ff731d"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDigital);
export default __webpack_public_path__ + "static/media/icon-digital.d3949afd.svg";
export { ForwardRef as ReactComponent };